import { useEffect, useState } from 'react';
import { Column } from '@uikit/Tables/types';
import { useForm } from '@hooks/useDirtyForm';
import { MonitoringRideGridTableOptions } from '@component/Monitoring/constants';

export const useColumnOrder = (columns: Column[]) => {
  const [columnOrder, setColumnOrder] = useState<Column[]>(columns);

  const { control, watch, reset } = useForm<MonitoringRideGridTableOptions>({
    defaultValues: {},
  });

  useEffect(() => {
    if (columns.some((el) => el.headerName === 'checkboxes')) {
      const defaultValues: Record<string, unknown> = {};
      columns.forEach((el) => {
        if (el.field) defaultValues[el.field] = el.isChecked;
      });
      reset(defaultValues);
    }
  }, []);

  useEffect(() => {
    const subscription = watch((value) => {
      setColumnOrder(columns.filter((col) => !col.field || value[col.field]));
    });
    return () => subscription.unsubscribe();
  }, [columns, watch]);

  useEffect(() => {
    setColumnOrder(
      columns.some((el) => el.headerName === 'checkboxes')
        ? columns.filter((el) => el.isChecked)
        : columns
    );
  }, [columns]);

  return { columnOrder, setColumnOrder, control };
};
